import { Injectable } from '@angular/core';
import { DomainAwarenessService } from 'ngx-shared-services';
import { environment } from '@/environments/environment';
import { APIEndpoints } from '@/environments/environment.interface';

@Injectable({ providedIn: 'root' })
export class ApiEndpointsService implements APIEndpoints {

  private readonly endpoints: APIEndpoints;

  constructor(
    private domainAwarenessService: DomainAwarenessService,
  ) {
    const { brand } = this.domainAwarenessService;
    if (!brand) console.warn(`Could not infer brand from domain, reverting to default: ${environment.defaults.brand}`);
    const endpoints = {
      fromDomainBrand: (brand) ? environment.brands[brand] : null,
      fromDefaultBrand: environment.brands[environment.defaults.brand],
    };
    const effectiveEndpoints = endpoints.fromDomainBrand || endpoints.fromDefaultBrand;
    if (effectiveEndpoints) this.endpoints = effectiveEndpoints;
    else throw new Error(`Missing api endpoints in environment for brand: ${brand || environment.defaults.brand}`);
  }

  get baseUrl(): string {
    return this.endpoints.baseUrl;
  }

  get globalNavUrl(): string {
    return this.endpoints.globalNavUrl;
  }
}